import { isNil, isObject, isPlainObject } from 'lodash';
import { Env } from './captcha';
export type ServiceEnv = 'rc' | 'opdev' | 'live' | 'stage' | 'sb';

export const isIncludes = <T extends string>(baseArr: T[], target: string): target is T => {
  if (baseArr.includes(target as T)) {
    return true;
  } else {
    return false;
  }
};

export const convertBrTag = (msg: string) => {
  return msg.replace(/(?:\r\n|\r|\n)/g, '<br />');
};

// 날짜 포메팅 방식 변경
// 2022-05-03 10:00:00
// formatHeaderStartDate: 2022-05-03
// formatStartDate: 2022. 05. 03.
// formatStartTime, formatEndTime: 10:00:00
export const formatCouponDate = (
  startDate: string,
  endDate: string
): {
  formatStartDate: string;
  formatEndDate: string;
  formatStartTime: string;
  formatEndTime: string;
  formatHeaderStartDate: string;
  formatHeaderEndDate: string;
} => {
  const tempStartDate = startDate.split(' ');
  const tempEndDate = endDate.split(' ');

  const formatHeaderStartDate = startDate.split(' ')[0];
  const formatHeaderEndDate = endDate.split(' ')[0];

  const formatStartDate = `${tempStartDate[0].split('-').join('. ').trim()}.`;
  const formatEndDate = `${tempEndDate[0].split('-').join('. ').trim()}.`;

  const _startHour = tempStartDate[1]?.split(':')[0];
  const _startMin = tempStartDate[1]?.split(':')[1];
  const _startSec = tempStartDate[1]?.split(':')[2];

  const _endHour = tempEndDate[1]?.split(':')[0];
  const _endtMin = tempEndDate[1]?.split(':')[1];
  const _endSec = tempEndDate[1]?.split(':')[2];

  const formatStartTime = `${_startHour}:${_startMin}`;
  const formatEndTime = `${_endHour}:${_endtMin}`;

  return {
    formatStartDate,
    formatEndDate,
    formatStartTime,
    formatEndTime,
    formatHeaderStartDate,
    formatHeaderEndDate,
  };
};

export const getCouponDate = (
  isArabic: boolean,
  formatStartTime: string,
  formatEndTime: string,
  formatStartDate: string,
  formatEndDate: string,
  utcString?: string
) => {
  const reverseFormatHeaderStartDate = formatStartDate.split('-').reverse().join('-');
  const reverseFormatHeaderEndDate = formatEndDate.split('-').reverse().join('-');

  const couponDate = `${
    isArabic ? reverseFormatHeaderStartDate : formatStartDate
  }${formatStartTime} ~ ${
    isArabic ? reverseFormatHeaderEndDate : formatEndDate
  }${formatEndTime}${utcString}`;
  return couponDate;
};

// [TODO] 서비스망 가져오기, 수정필요
export const getSeviceEnv = (): Env => {
  const networkPattern: { name: Env; pattern: RegExp | null }[] = [
    { name: 'op', pattern: /^(local|opdev)/ },
    { name: 'sb', pattern: /^sb|test/ },
    { name: 'rc', pattern: /^rc/ },
    { name: 'live', pattern: null },
  ];

  const host = location.hostname;
  let network: Env = 'live';

  networkPattern.some((net) => {
    if (net.pattern) {
      if (net.pattern.test(host)) {
        network = net.name;
        return true;
      }
    } else {
      if (net.name === 'live') {
        network = net.name;
        return true;
      }
    }
    return false;
  });

  return network;
};

export const disableElement = (element: Element | null, flag: boolean) => {
  if (isNil(element)) return;

  if (flag) {
    element.setAttribute('disabled', 'true');
  } else {
    element.removeAttribute('disabled');
  }
};

// HEX > RGBA
export const convertHexToRGBA = (
  hexCode: string,
  opacity: number = 1,
  onlyRgb: boolean = false
) => {
  if (!hexCode) return;
  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  if (opacity > 1 && opacity <= 100) {
    opacity = opacity / 100;
  }
  if (onlyRgb) return `${r}, ${g}, ${b}`;
  else return `rgba(${r},${g},${b},${opacity})`;
};

// export const getByte = ()=> {
//   let byteLength = _._getByteLength(_._$emailInput.val().split('@')[0]);

//   if(byteLength > 64){
//     alert(msg['preorder.record.alert.error_pattern_email']);
//     _._$emailInput.val('');
//     return false;
//   }
// }

export const getByteLength = (s: string, b?: any, i?: any, c?: any) => {
  // eslint-disable-next-line no-cond-assign
  for (b = i = 0; (c = s.charCodeAt(i++)); b += c >> 11 ? 2 : c >> 7 ? 2 : 1);
  return b;
};

// extraData 세팅
export const getExtraData = (
  addedObj: Record<string, any> = {},
  _isCheckedAllConsignmentAgrees?: boolean
) => {
  let extraDatas = [];

  for (let key in addedObj) {
    addedObj[key] && extraDatas.push(`${key}:${addedObj[key]}`);
  }

  // 퍼플 인앱 모드 인가?
  if (window._isPurple === true || window._isPurple === 'true') extraDatas.push('isPruple: true');

  // const params = getParamsFromUri(location.search); // 이걸로 해도 됨
  let params: Record<string, string> = {};

  const searchParmas = new URLSearchParams(location.search);
  for (const [key, value] of searchParmas) {
    params[key] = value;
  }

  if (!isNil(params.invitationCode)) {
    try {
      // set invitation code
      params.invitationCode = window.atob(window.decodeURIComponent(params.invitationCode));
    } catch (error) {
      // Failed to execute 'atob' on 'Window': The string to be decoded is not correctly encoded.
    }
  }

  // advertisement inflow route
  const q = getUriCombinedParams('q:', params);

  if (location.search) extraDatas.push(`${q}`.substring(0, 200)); // from previous server-side javascript

  // flag checked agree consignment checkbox
  if (!isNil(_isCheckedAllConsignmentAgrees)) {
    extraDatas.push(`agreeConsignment:${_isCheckedAllConsignmentAgrees}`);
  }

  if (extraDatas.length > 0) return extraDatas.join(',');

  return '';
};

export const getParamsFromUri = (uri: string) => {
  let obj: Record<string, string> = {};

  if (uri.length < 1) return obj;
  uri = uri.split('#')[0];

  let tmpArr = uri.split('?');
  if (tmpArr.length < 2) return obj;

  const paramStr = tmpArr[1];
  const params = paramStr.split('&');

  for (let param, keyStr = '', valueStr = '', i = 0, max = params.length; i < max; ++i) {
    param = params[i];

    const eqIndex = param.indexOf('=');
    if (eqIndex >= 0) {
      keyStr = param.substring(0, eqIndex);
      valueStr = param.substring(eqIndex + 1);

      obj[keyStr] = valueStr;
    }
  }

  return obj;
};

export const getParamsFromCurrentUri = () => {
  return getParamsFromUri(location.href);
};

export const getUriCombinedCurrentParam = (uri: string) => {
  return getUriCombinedParams(uri, getParamsFromCurrentUri());
};

export const getUriCombinedParams = (uri: string, parameters: Record<string, string>) => {
  if (typeof uri !== 'string')
    throw new TypeError('uri parameter type of getUriCombinedParams() must be String.');

  if (!isPlainObject(parameters))
    throw new TypeError('parameters parameter type of getUriCombinedParams() must be Object.');

  if (!uri) return '';
  if (!parameters) return uri;

  let str = '';
  for (let key in parameters) {
    str += '&' + key + '=' + String(parameters[key]);
  }

  if (str === '') return uri;

  let tmpArr = uri.split('#');
  let hashStr = !isNil(tmpArr[1]) ? '#' + tmpArr[1] : '';

  uri = tmpArr[0];
  uri = (uri.indexOf('?') >= 0 ? uri + str : uri + '?' + str.substr(1)) + hashStr;

  return uri;
};

export const jsonParsingWithFallback = <T>(string: string, fallBack: T): T => {
  try {
    return JSON.parse(string);
  } catch (error) {
    return fallBack;
  }
};

export const getApiPathPrefix = () => {
  const matchResult = location.pathname.match(/(^\/.+)\/preorder\//);
  return (!isNil(matchResult) && matchResult[1]) || '';
};

export const getCookie = (key: string = '') => {
  let cookieKey = key + '=';
  let result = '';
  const cookieArr = document.cookie.split(';');
  for (let i = 0; i < cookieArr.length; i++) {
    cookieArr[i] = cookieArr[i].trim();

    if (cookieArr[i].indexOf(cookieKey) === 0) {
      result = cookieArr[i].slice(cookieKey.length, cookieArr[i].length);
      return result;
    }
  }
  return result;
};

// 'yyyy-mm-dd hh:mm:ss' 의 형식을 KST(+09:00) 로 간주하고, Date 객체로 변환 -> getTime으로 변환
export const getTimeAsKst = (stringDate: string) => {
  // stringDate: '2022-05-03 10:00:00'
  const _stringDate = stringDate.replace(' ', 'T');
  const userDataNow = window.userData?.now;
  const utcString = /(?:-|\+)\d{2}:\d{2}/g.exec(userDataNow);
  const utc = utcString ? utcString[0] : '+09:00';
  return new Date(`${_stringDate}${utc}`).getTime();
};

// Date객체를 특정형식으로 변환 ex) 'YYYY-MM-DD HH:mm:ss'
export const getDateFormat = (date: Date = new Date(), format: string = 'YYYY-MM-DD HH:mm:ss') => {
  const getH = (h: number, num: number) => {
    const reh = h % 12;

    return num == 1 ? reh : reh >= 10 ? reh : '0' + reh;
  };
  const meridiemFunc = (hour: number, isLowercase: boolean) => {
    const m = hour < 12 ? 'AM' : 'PM';
    return isLowercase ? m.toLowerCase() : m;
  };

  const matches: any = {
    YY: String(date.getFullYear()).slice(-2),
    YYYY: date.getFullYear(),
    M: date.getMonth() + 1,
    MM: date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + Number(date.getMonth() + 1),
    D: date.getDate(),
    DD: date.getDate() >= 10 ? date.getDate() : '0' + date.getDate(),

    H: date.getHours(),
    HH: date.getHours() >= 10 ? date.getHours() : '0' + date.getHours(),
    h: getH(date.getHours(), 1),
    hh: getH(date.getHours(), 2),
    a: meridiemFunc(date.getHours(), true),
    A: meridiemFunc(date.getHours(), false),
    m: date.getMinutes(),
    mm: date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes(),
    s: date.getSeconds(),
    ss: date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds(),
  };
  const txt = format.replace(
    /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
    (match: string, key: string) => {
      //return matches[match];
      return key || matches[match];
    }
  );
  return txt;
};

// 현재 시간 = 페이지 진입시점의 서버 시간 + 이 함수가 호출 될때까지 지난 시간
export const getNowTimeUsingUserdataNow = (): number | null => {
  const userDataNow = window.userData.now;
  if (!userDataNow) return null;

  const serverTimeAtArrivedWebPage = new Date(window.userData.now).getTime(); //'2022-07-12T10:50:45.05193+09:00'
  const pastTimeFromArrivedWebPage = window.performance.now();

  return serverTimeAtArrivedWebPage + pastTimeFromArrivedWebPage;
};

export const getMobileOS = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) {
    return 'Android';
  } else if (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  ) {
    return 'ios';
  }
  return 'Other';
};

interface Created {
  countryList: any[];
  languageList: any[];
  snsList: ({ name: string; link: string } | { name: string; link: string })[];
  linkList: (
    | { name: string; link: string; type: string; target: string }
    | { name: string; link: string; type: string; target: string }
    | { name: string; link: string; type: string; target: string }
  )[];
  csInfoType: string;
  copyright: string;
  companyLink: string;
  communityPolicyLink: string;
}
